// extracted by mini-css-extract-plugin
export default {"viewSelector":"view-selector_viewSelector__pmUCb","viewButton":"view-selector_viewButton__RaAjV"};